import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SubSink } from "subsink";
import { ArrayHelper } from "../../../../utilities/contracts/array-helper";
import { MemberItem } from "../../../api/member-v2/member-item.model";
import { MemberV2Service } from "../../../api/member-v2/member-v2.service";
import { MemberDetail } from "./member-detail.model";
import { MemberStateService } from "./member-state.service";

@Component({
  selector: "app-member-detail-v2",
  templateUrl: "./member-detail-v2.component.html",
  styleUrls: ["./member-detail-v2.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberDetailV2Component implements OnInit, OnDestroy {

   private sink = new SubSink();
   memRecId: string | null = null;
   memberId: string;
   hasConflict = false;

   constructor(
      private memberService: MemberV2Service,
      private memberStateService: MemberStateService,
      private route: ActivatedRoute,
      private router: Router
    ) { }

   ngOnInit(): void {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.route.paramMap.subscribe(params => {
          this.memRecId = params.get("memRecordId");
          this.memberId = params.get("memberId") || "";
      });


      if (!history.state.memberId) {
        this.sink.add(
          this.memberService.getMemberById(this.memberId, true, true).subscribe(data => {
            const state = data.filter(rec => ArrayHelper.isAvailable(rec.records) && rec.records.some(r => this.memRecId === r.memRecordId))[0];
            const memberRecord = state.records.filter(r => r.memRecordId === this.memRecId)[0] as MemberItem;
            this.hasConflict = state.records.filter(r => r.conflictFlag).length > 0;
            const member = new MemberDetail({
              memberFirstName: memberRecord.firstName,
              memberLastName: memberRecord.lastName,
              memberId: state.memberId,
              memberDateOfBirth: memberRecord.dob,
              memberGender: memberRecord.gender,
            });
            this.memberStateService.setData({
              ...member,
            });
          })
        );
      } else if (history.state.memberId) {
        this.memberStateService.setData({
          ...history.state,
        });
      } else {
        this.router.navigateByUrl(`/chartlake/membersnew`);
      }
    }

   ngOnDestroy() {
      this.memberStateService.clearData();
      this.sink.unsubscribe();
    }

}
